import { render } from "./ComingSoon.vue?vue&type=template&id=4e71fdce&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=4e71fdce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e71fdce"

export default script